module.exports = __webpack_public_path__ + "img/工厂_factory-building.0ba8c994.svg";